module.exports = __webpack_public_path__ + "assets/images/feedback_fd939397894b253a9207e5ae19f8e32e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-five/feedback.png
// module id = 220
// module chunks = 0